import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

import type {
  CampaignCorrectionPayloadType,
  CampaignCorrectionResponseType,
  CampaignExportResponseType,
  CampaignFilterParamsType,
  CampaignHistoryParamsType,
  CampaignHistoryResponseType,
  CampaignListResponseType,
  CampaignWidgetSummaryResponseType,
} from '../@types/campaignTypes'

const omitEmptyParams = <T extends Record<string, unknown>>(params: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  ) as Partial<T>

export const submitCampaignCorrectionsApi = (data: CampaignCorrectionPayloadType[]) =>
  axiosInstanceApiGateway.Post<CampaignCorrectionResponseType, true>({
    url: '/commercial/internal/:version/scms/campaigns/corrections',
    version: 'v1',
    data,
  })

export const fetchScmsCampaignListApi = (params: CampaignFilterParamsType) =>
  axiosInstanceApiGateway.Get<CampaignListResponseType, true>({
    url: '/analytics-data/internal/:version/scms/forecasts/campaigns',
    version: 'v1',
    params: omitEmptyParams(params),
  })

export const fetchCampaignWidgetSummaryApi = (params: Partial<CampaignFilterParamsType>) =>
  axiosInstanceApiGateway.Get<CampaignWidgetSummaryResponseType, true>({
    url: '/analytics-data/internal/:version/scms/forecasts/campaigns/widget-summary',
    version: 'v1',
    params: omitEmptyParams(params),
  })

export const fetchCampaignNeedPlanCountApi = (params: Partial<CampaignFilterParamsType>) =>
  axiosInstanceApiGateway.Get<{ data: { total_need_plans: number } }, true>({
    url: '/analytics-data/internal/:version/scms/forecasts/campaigns/total:needPlans',
    version: 'v1',
    params: omitEmptyParams(params),
  })

export const fetchCampaignHistoryApi = (params: CampaignHistoryParamsType) =>
  axiosInstanceApiGateway.Get<CampaignHistoryResponseType, true>({
    url: '/analytics-data/internal/:version/scms/forecasts/campaigns/history',
    version: 'v1',
    params: omitEmptyParams(params),
  })

export const exportCampaignApi = (params: Partial<CampaignFilterParamsType>) =>
  axiosInstanceApiGateway.Get<CampaignExportResponseType, true>({
    url: '/analytics-data/internal/:version/scms/forecasts/campaigns/export',
    version: 'v1',
    params: omitEmptyParams(params),
  })
